import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseMagFooter() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, imgState, setter) {
    let errorState = {
      title: isEmpty(state.title),
      url: isEmpty(state.url),
      file1: isEmpty(imgState.url1),
      file2: isEmpty(imgState.url2),
    };

    setter(errorState);

    if (errorState.title || errorState.url) {
      enqueueSnackbar("لطفا اطلاعات فوتر را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetMagFooter = (callback) => {
    MyAxios.get(`Admin_Mag_HomePage/GetFooter`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const SetMagFooter = (state, logo1, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (logo1) {
      data.append("logo1", logo1);
    }
    MyAxios.post(`Admin_Mag_HomePage/SetFooter`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محتوای فوتر با موفقیت تنظیم شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    validate,
    GetMagFooter,
    SetMagFooter,
  };
}
